<template>
  <div class="admin-dashboard-wrapper">
    
    <AdminNavbar />

    <div class="dashboard-content-container container">
      
      <section class="admin-profile-section card-style profile-accent">
        <div class="profile-left">
          <div class="admin-picture-placeholder">
            <span class="initials">{{ adminInitials }}</span>
          </div>
        </div>
        
        <div class="profile-right">
          <h2 class="admin-name">{{ adminData.username || 'Administrator' }}</h2>
          <p class="admin-email">{{ adminData.email || 'admin@salon.com' }}</p>
         </div>
      </section>
        <section class="appointment-management-section">
                <AppointmentList />
            </section>
      <div class="dashboard-grid">
        
        <section class="stylist-management-section card-style">
          <h3 class="section-title">🧑‍🎨 Stylists ({{ stylists.length }})</h3>
          
          <ul class="stylist-list" v-if="stylists.length">
            <transition-group name="list">
            <li v-for="stylist in stylists" :key="stylist.id" class="stylist-item" @click="selectStylist(stylist)">
              <span class="stylist-name-display cursor-pointer">{{ stylist.full_name }} </span>
<span 
        class="delete-stylist-btn" 
        @click.stop="deleteStylist(stylist.id)"
        :class="{ 'is-loading': deletingId === stylist.id }"
    >
        <span v-if="deletingId === stylist.id">...</span>
        <span v-else>&times;</span>
    </span> 
    </li>
            </transition-group>
          </ul>

          <p v-else class="no-stylists-msg">Loading stylist data...</p>

        </section>

      </div>

      <div 
        v-if="showEditStylist" 
        class="stylist-details-area"
      >
          <EditStylist
            :stylist-data="selectedStylist"
            @close-modal="closeEditStylist"
          />
      </div>
    </div>
  </div> 
</template>
   

<script>
import axios from 'axios'
import axiosInstance from '@/services/AxiosClient'
import AdminNavbar from '@/components/admin/AdminNavbar.vue'
import EditStylist from '@/components/admin/EditStylist.vue'
import AppointmentList from '@/components/admin/AppointmentList.vue'

const API_BASE_URL = 'https://api-afrobraids.inchtechs.com/api/'

export default {
    name: 'AdminDashboard',
    components: {
        AdminNavbar,
        EditStylist,
        AppointmentList
    },
    props: { 
    },
    data() {
        return {
            adminData: {
                username: 'Administrator',
                email: 'admin@salon.com'
            },
            stylists: [],
            error : null, // Array to hold stylist data
            deletingId: null,

            showEditStylist: false,
            selectedStylist: null
        }
    },
    created() {
        /*const adminInfo = localStorage.getItem("adminUser")
        let user = JSON.parse(adminInfo)
        if(!adminInfo) {
            this.$router.push({ name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        } else if(!user.access_token) {
            this.$router.push({name: 'Authenticate'})
            console.log("Sign in before you can load the component")
        } else{*/
        console.log("This component is created, admin dashboard")
        this.loadAdminData(); 
    },
    mounted() {
        this.fetchStylists()
    },
    methods : {
        selectStylist(stylist) {
            this.selectedStylist = stylist
            this.showEditStylist = true
        },
        closeEditStylist() {
            // Method executed when EditStylist emits 'close-modal'
            this.showEditStylist = false;
            this.selectedStylist = null;
        },
        loadAdminData() {
            const userData = localStorage.getItem('adminUser');
            if (userData) {
                try {
                    this.adminData = JSON.parse(userData);
                } catch (e) {
                    console.error("Error parsing admin data from storage: ", e)
                }
            } else {
                console.log("No user data found")
            }
        },
        // --- 
        async fetchStylists() {
            try {
                const response = await axiosInstance.get(`user/get_users`)
                this.stylists = response.data.filter( user => user.role.toLowerCase() === 'stylist')
            } catch(error) {
                console.error("Error fetching data:", error);
                // Handle network errors or non-200 status codes
                this.error = 'Failed to load products. Please try again later.';
            }
        },

        logout() {
            // Clear storage and redirect back to login
            localStorage.removeItem('adminUser');

            this.adminData = {
                username: null,
                email: null
            };

            this.$router.push({ name: 'Authenticate' })
        },
        goToProfile() {
            this.$router.push({ name: 'AdminProfile' }); 
        },
        goToServices() {
             this.$router.push({ name: 'adminServices' });
        },
        goToStylistManagement() {
             // Placeholder for router push to a detailed stylist management page
             console.log("Navigating to Stylist Management Page...");
        },
        async deleteStylist(stylistID){
            if (!confirm("Are you sure you want to delete this stylist?")) return;

            // Track which ID is being deleted to show feedback
            this.deletingId = stylistID;
            console.log("Deleting stylist: ", stylistID)
            try{
                const response = await axios.delete(`${API_BASE_URL}user/delete/${stylistID}`)
                this.stylists = this.stylists.filter(s => s.id !== stylistID);
                console.log("Successfully deleted stylist, ", response.data)
            } catch(error) {
                console.log("Error deleting data from the database, ", error)
            } finally {
                this.deletingId = null
            }
        }
    },
    computed: {
        adminInitials() {
            if (this.adminData.username) {
                return this.adminData.username.charAt(0).toUpperCase();
            }
            return 'A'; // Default initial
        }
    }
}
</script>

<style scoped>

.admin-dashboard-wrapper {
    min-height: 100vh;
    background-color: var(--color-light); 
    font-family: var(--font-sans);
}

.container {
    max-width: 1300px;
    margin: 0 auto;
    padding: 0 1.5rem;
}

.stylist-details-area {
    margin-top: 25px; /* Adds space between the grid and the details card */
}

/* Ensures that the grid doesn't rely on the component for margin */
.dashboard-content-container {
    padding: 2rem 1.5rem;
}

/* 1. Grid Layout for main conte */
.dashboard-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 25px;
}
@media (min-width: 900px) {
    .dashboard-grid {
        grid-template-columns: 1fr; 
    }
    /* Let's them vertically on the right */
    @media (min-width: 1100px) {
        .dashboard-grid {
             grid-template-columns: 1fr;
        }
    }
}


/* 2. Card Styling */
.card-style {
    background-color: white;
    padding: 2.5rem;
    border-radius: 12px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease;
}

.card-style:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
}

.section-title {
    font-family: var(--font-serif);
    font-size: 1.6rem;
    color: var(--color-maroon);
    border-bottom: 2px solid var(--color-gold); 
    padding-bottom: 10px;
    margin-bottom: 20px;
}

/* 3. Profile Section Styling */
.admin-profile-section {
    display: flex;
    align-items: center;
    gap: 30px;
}

.profile-accent {
    border-left: 6px solid var(--color-maroon); 
    margin-bottom: 2rem;
}

.admin-picture-placeholder {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background-color: var(--color-earth); 
    border: 3px solid var(--color-gold); 
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    color: white;
    font-weight: bold;
    flex-shrink: 0;
}

.admin-name {
    font-size: 2rem;
    color: var(--color-dark);
    margin-bottom: 5px;
    font-weight: 700;
}

.admin-email, .admin-status {
    color: #555;
    font-size: 1rem;
    margin-bottom: 3px;
}

.status-tag {
    display: inline-block;
    padding: 4px 10px;
    margin-top: 5px;
    border-radius: 4px;
    background-color: #e6ffe6;
    color: green;
    font-weight: 600;
    font-size: 0.9rem;
}

.profile-action-btn {
    background-color: var(--color-earth);
    color: white;
    padding: 8px 20px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-weight: 500;
    margin-top: 15px;
}
.profile-action-btn:hover {
    background-color: #8d4523;
}


/* 4. Sales Trend Placeholder Styling */
.trend-placeholder {
    height: 300px;
    background-color: var(--color-light); 
    border: 1px dashed var(--color-gold);
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--color-earth);
    font-style: italic;
    font-weight: 600;
    font-family: var(--font-serif);
}

/* 5. Service Management Section */
.add-service-controls {
    display: flex;
    flex-direction: column; 
    align-items: flex-start;
    gap: 15px;
}

.control-text {
    color: var(--color-dark);
    font-size: 1.05rem;
    flex-grow: 1;
}

.add-service-btn {
    padding: 12px 25px;
    background-color: var(--color-maroon); 
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s, transform 0.2s;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.add-service-btn:hover {
    background-color: #4a0c19;
    transform: translateY(-1px);
}

.full-width-btn {
    width: 100%;
    margin-top: 20px;
}

.stylist-list {
    list-style: none;
    padding: 0;
    margin-bottom: 20px;
    max-height: 250px;
    overflow-y: auto;
}

.stylist-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    margin-bottom: 8px;
    background-color: var(--color-light);
    border-radius: 6px;
    border-left: 3px solid var(--color-gold);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

    position: relative;
    cursor: pointer;
}

.stylist-name-display {
    font-weight: 600;
    color: var(--color-dark);
    flex-grow: 1;
}

.delete-stylist-btn {
    opacity: 0;
    visibility: hidden;
    
    /* Styling for the X */
    background-color: #f8d7da;
    color: #721c24;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-weight: bold;
    font-size: 16px;
    transition: all 0.2s ease;
    cursor: pointer;
}

/* When the ROW (stylist-item) is hovered, show the BUTTON */
.stylist-item:hover .delete-stylist-btn {
    opacity: 1;
    visibility: visible;
}

/* Make the X turn darker red when hovered directly */
.delete-stylist-btn:hover {
    background-color: #721c24;
    color: white;
    transform: scale(1.1);
}

.stylist-status {
    font-size: 0.85rem;
    font-weight: 700;
    padding: 4px 8px;
    border-radius: 10px;
    margin-right: 15px;
}

.stylist-status.online {
    background-color: #d4edda;
    color: #155724;
}

.stylist-status.offline {
    background-color: #f8d7da;
    color: #721c24;
}

.stylist-action-btn {
    background-color: var(--color-earth);
    color: white;
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    font-size: 0.9rem;
    cursor: pointer;
    transition: background-color 0.3s;
}

.stylist-action-btn:hover {
    background-color: #8d4523;
}

.no-stylists-msg {
    text-align: center;
    padding: 20px;
    font-style: italic;
    color: #888;
}

.list-leave-active {
  transition: all 0.4s ease;
}
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
/* Smoothly sliding remaining items up */
.list-move {
  transition: transform 0.4s ease;
}

/* Responsiveness for wider screens */
@media (min-width: 768px) {
    /* Side-by-side layout for service controls */
    .add-service-controls {
        flex-direction: row; 
        justify-content: space-between;
        align-items: center;
    }
    
    .control-text {
        max-width: 70%;
    }
}
</style>